export function validatePhoneNumber(phone: string): boolean {
  // This regular expression allows '+', numbers, spaces, and '-'.
  const re = /^[0-9+\-\s]+$/
  return re.test(String(phone))
}

export function validateEmail(email: string): boolean {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export function validateName(name: string): boolean {
  return name !== ''
}

export async function getRecaptchaToken(executeRecaptcha: any) {
  const isDevelopmentMode =
    process.env.NODE_ENV === 'development' ||
    (typeof window !== 'undefined' &&
      ['localhost', '127.0.0.1'].includes(window.location.hostname))

  if (isDevelopmentMode) return 'development-mode-no-recaptcha'

  if (!executeRecaptcha) throw new Error('reCAPTCHA not initialized')
  return executeRecaptcha('contact_form')
}
